/**
 * @ignore
 */
import { useEffect, useContext } from 'react';
import { Context } from '../componentsInternal/InnerHtmlProvider';
// Placeholder ID, just gives us a unique identifier
let placeholderScriptId = 0;
const nextPlaceholderId = () => 'placeholder_script_' + placeholderScriptId++;
/**
 * Injects the custom HTML and adds scripts to the Scripts Context.
 * NOTE: for use only with InnerHtml component
 */
export function useInjectCustomHTML({ html, containerRef, }) {
    const scriptContext = useContext(Context);
    useEffect(() => {
        if (!html)
            return;
        // Create a 'tiny' document and parse the html string
        const slotHtml = document.createRange().createContextualFragment(html);
        // Scripts don't wait for the previous ones to load, so remove them from the document fragment
        // and manually load them ourselves.
        const scripts = slotHtml.querySelectorAll('script'); // eslint-disable-line testing-library/no-node-access
        scripts.forEach((s) => {
            var _a;
            const placeholderScript = document.createElement('script');
            placeholderScript.id = nextPlaceholderId();
            (_a = s.parentNode) === null || _a === void 0 ? void 0 : _a.replaceChild(placeholderScript, s); // eslint-disable-line testing-library/no-node-access
            scriptContext.addScript(s, placeholderScript);
        });
        // Insert custom html (without scripts)
        if (containerRef.current) {
            containerRef.current.innerHTML = ''; // Clear the container
            containerRef.current.appendChild(slotHtml); // Append the new content
        }
    }, [html, scriptContext, containerRef]);
}
//# sourceMappingURL=useInjectCustomHTML.js.map